@if(this.user$){

  <ng-template #templateTooltip let-anchor >
    <div kendoTooltip
    tooltipClass="ece-tooltip"
    [tooltipTemplate]="templateTooltip"
    [innerHTML]="anchor.nativeElement.getAttribute('data-title')"></div>
    {{ anchor.nativeElement.getAttribute('data-title') ? '' : ('tooltip.loading' | i18n) }}
  </ng-template>
  
  <circ-chrome [person]="user$ | async"
  [stageMark]="$stageMark | async"
  (toggleLanguageClick)="toggleLanguageClick()"
  (aboutClick)="aboutMeClick()"
  (logoutClick)="logoutClick()"
  (iconClick)="toInformationClick()"
  ></circ-chrome>
  <div kendoTooltip
  tooltipClass="ece-tooltip"
  [tooltipTemplate]="templateTooltip"
  >
  <circ-menu-shell (navClick)="onNavClick($event)">
    <main class="container-fluid px-0">
      <div class="container">
        <router-outlet></router-outlet>
      </div>
    </main>
  </circ-menu-shell>
</div>
<div kendoDialogContainer></div>
}